import { render, staticRenderFns } from "./MoreWork.vue?vue&type=template&id=6a2a59e0&"
import script from "./MoreWork.vue?vue&type=script&lang=js&"
export * from "./MoreWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports